'use client'

import { type ComponentProps, Suspense } from 'react'

import dynamic from 'next/dynamic'

import { LabScoreCardLoading } from './lab-score-card-loading'
import type { LabScoreCardWide } from './lab-score-card-wide'

const Card = dynamic(() => import('./lab-score-card-wide').then((module) => module.LabScoreCardWide))

export const LabScoreCardWideLazy = (props: ComponentProps<typeof LabScoreCardWide>) => (
  <Suspense fallback={<LabScoreCardLoading title={props.product.label} attribution={props.attribution} />}>
    <Card {...props} />
  </Suspense>
)
